const TOOLS = {
  chat: {
    route: "/chat",
    label: "AI Chat",
    description: "Answer questions and have a conversation",
  },
  marketing: {
    route: "/marketing",
    label: "Marketing",
    description: "Create social media posts with AI copy and image generation",
  },
  image: {
    route: "/image",
    label: "Image Generation",
    description: "Create images from a text prompt",
  },
  imageStudio: {
    route: "/image-studio",
    label: "Image Studio",
    description: "Layer images and add text overlays",
  },
  video: {
    route: "/video",
    label: "Video Generation",
    description: "Video generation is coming soon",
    comingSoon: true,
  },
  tts: {
    route: "/tts",
    label: "Text to Speech",
    description: "Turn text into spoken audio",
  },
  studio: {
    route: "/studio",
    label: "Video Studio",
    description: "Build a multi-scene video project",
  },
  shortsStudio: {
    route: "/shorts",
    label: "Shorts Studio",
    description: "Turn YouTube links into short-form winning video formats",
  },
  model3d: {
    route: "/model3d",
    label: "3D Model Studio",
    description: "Generate downloadable 3D meshes for games and apps",
  },
  code: {
    route: "/code",
    label: "Code Editor",
    description: "Write or generate code with AI",
  },
};

const MATCHERS = [
  {
    tool: "model3d",
    score: 7,
    patterns: [
      /\b3d model\b/i,
      /\b3d mesh\b/i,
      /\bglb\b/i,
      /\bstl\b/i,
      /\bcadquery\b/i,
      /\bcad model\b/i,
      /\b3d print\b/i,
      /\bgame asset\b/i,
      /\bgame prop\b/i,
      /\bunity model\b/i,
      /\bunreal model\b/i,
      /\b3d object\b/i,
      /\bmodel studio\b/i,
      /\btext to 3d\b/i,
      /\bimage to 3d\b/i,
    ],
  },
  {
    tool: "shortsStudio",
    score: 7,
    patterns: [
      /\byoutube shorts?\b/i,
      /\bshorts generator\b/i,
      /\bturn .*youtube.* into shorts?\b/i,
      /\bviral short(s)? format\b/i,
      /\branking list video\b/i,
      /\bshort-form video\b/i,
      /\bclip this youtube video\b/i,
    ],
  },
  {
    tool: "imageStudio",
    score: 6,
    patterns: [
      /\bimage studio\b/i,
      /\blayer images?\b/i,
      /\btext overlays?\b/i,
      /\badd text to image\b/i,
      /\bposter editor\b/i,
      /\bflyer design\b/i,
      /\bsocial post design\b/i,
      /\bedit image layout\b/i,
    ],
  },
  {
    tool: "marketing",
    score: 6,
    patterns: [
      /\bsocial media\b/i,
      /\bmarketing post\b/i,
      /\bpromo post\b/i,
      /\bpromotional post\b/i,
      /\binstagram post\b/i,
      /\blinkedin post\b/i,
      /\btiktok post\b/i,
      /\bad copy\b/i,
      /\bcaption and image\b/i,
      /\bpost for my business\b/i,
    ],
  },
  {
    tool: "code",
    score: 5,
    params: { codeMode: "react-native", mode: "generate" },
    patterns: [
      /\breact native\b/i,
      /\bexpo go\b/i,
      /\bmobile app\b/i,
      /\bios app\b/i,
      /\bandroid app\b/i,
      /\bphone app\b/i,
    ],
  },
  {
    tool: "code",
    score: 4,
    params: { codeMode: "react-web", mode: "generate" },
    patterns: [
      /\breact web\b/i,
      /\blanding page\b/i,
      /\bweb app\b/i,
      /\bwebsite\b/i,
      /\bfrontend\b/i,
    ],
  },
  {
    tool: "studio",
    score: 5,
    patterns: [
      /\bvideo studio\b/i,
      /\bvideo project\b/i,
      /\bscene(s)?\b/i,
      /\btimeline\b/i,
      /\bcaption(s)?\b/i,
      /\bslideshow\b/i,
      /\bvoiceover\b/i,
      /\bcombine clips\b/i,
    ],
  },
  {
    tool: "tts",
    score: 5,
    patterns: [
      /\btext to speech\b/i,
      /\bread (this|it|aloud)\b/i,
      /\bread aloud\b/i,
      /\bnarrat(e|ion|or)\b/i,
      /\bspeak (this|the following)\b/i,
      /\bvoice over\b/i,
      /\btts\b/i,
    ],
  },
  {
    tool: "video",
    score: 4,
    patterns: [
      /\btext to video\b/i,
      /\bvideo clip\b/i,
      /\bgenerate (a )?video\b/i,
      /\bmake (a )?video\b/i,
      /\banimate (this|a|the)\b/i,
      /\bai video\b/i,
    ],
  },
  {
    tool: "image",
    score: 4,
    patterns: [
      /\bgenerate (an? )?image\b/i,
      /\bcreate (an? )?image\b/i,
      /\bmake (an? )?image\b/i,
      /\bgenerate (an? )?(picture|photo|logo|poster|artwork|illustration|banner|icon|wallpaper)\b/i,
      /\bcreate (an? )?(picture|photo|logo|poster|artwork|illustration|banner|icon|wallpaper)\b/i,
      /\bmake (an? )?(picture|photo|image|logo|poster|artwork|banner|icon|wallpaper)\b/i,
      /\bdesign (an? )?(logo|poster|banner|icon|thumbnail|wallpaper)\b/i,
      /\bdraw (me )?(an? )?\b/i,
      /\billustrat(e|ion)\b/i,
      /\bimage of\b/i,
      /\bpicture of\b/i,
      /\bphoto of\b/i,
      /\blogo for\b/i,
      /\bwallpaper of\b/i,
      /\bvisual of\b/i,
    ],
  },
  {
    tool: "code",
    score: 3,
    params: { codeMode: "single", mode: "generate" },
    patterns: [
      /\bwrite code\b/i,
      /\bcode editor\b/i,
      /\bbuild (a )?(script|program|function|class)\b/i,
      /\bpython script\b/i,
      /\bjavascript\b/i,
      /\btypescript\b/i,
      /\bdebug (this|my) code\b/i,
    ],
  },
  {
    tool: "chat",
    score: 1,
    patterns: [
      /\bexplain\b/i,
      /\bwhat is\b/i,
      /\bhow do i\b/i,
      /\bwhy does\b/i,
      /\btell me about\b/i,
      /\bhelp me understand\b/i,
    ],
  },
];

function stripLeadIn(text) {
  return (
    text
      .replace(
        /^(please\s+)?(can you\s+)?(help me\s+)?(generate|create|make|draw|design|write|build|edit|code|produce)\s+(an?\s+)?(image|video|picture|photo|logo|poster|artwork|illustration|banner|icon|wallpaper|app|website|code|clip|audio|speech)\s+(of|for|about|that says)?\s*/i,
        ""
      )
      .trim() || text.trim()
  );
}

function detectCodeMode(text) {
  if (/\breact native\b|\bexpo\b|\bmobile app\b|\bphone app\b/i.test(text)) {
    return "react-native";
  }
  if (/\breact\b|\bwebsite\b|\blanding page\b|\bweb app\b/i.test(text)) {
    return "react-web";
  }
  if (/\bpython\b/i.test(text)) return "single";
  return "single";
}

function detectLanguage(text) {
  if (/\btypescript\b/i.test(text)) return "typescript";
  if (/\bpython\b/i.test(text)) return "python";
  if (/\bjavascript\b|\bjs\b/i.test(text)) return "javascript";
  return "javascript";
}

export function routePrompt(rawPrompt) {
  const prompt = String(rawPrompt || "").trim();
  if (!prompt) {
    return { ok: false, error: "Describe what you'd like to create." };
  }

  const lower = prompt.toLowerCase();
  let best = { tool: "chat", score: 0, params: {} };

  for (const matcher of MATCHERS) {
    for (const pattern of matcher.patterns) {
      if (pattern.test(lower)) {
        const score = matcher.score + (pattern.global ? 0 : 0);
        if (score > best.score) {
          best = {
            tool: matcher.tool,
            score,
            params: matcher.params || {},
          };
        }
      }
    }
  }

  const tool = TOOLS[best.tool] || TOOLS.chat;
  const cleaned = stripLeadIn(prompt);
  const params = { ...best.params };

  if (best.tool === "code" && !params.codeMode) {
    params.codeMode = detectCodeMode(prompt);
    params.language = detectLanguage(prompt);
    params.mode = params.mode || "generate";
  }

  if (best.tool === "studio") {
    params.studioCaption = cleaned;
  }

  return {
    ok: true,
    tool: best.tool,
    route: tool.route,
    label: tool.label,
    description: tool.description,
    comingSoon: Boolean(tool.comingSoon),
    prompt: cleaned,
    rawPrompt: prompt,
    params,
    confidence: best.score >= 4 ? "high" : best.score >= 2 ? "medium" : "low",
  };
}

export { TOOLS };
